(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vk-showcase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('.vk-thumbnail');
  if (!button) return;
  const gallery = button.closest('.vk-gallery');
  const image = gallery.querySelector('.vk-active-image');
  image.src = button.dataset.image;
  image.removeAttribute('srcset');
  image.alt = button.dataset.alt;
  gallery.querySelectorAll('.vk-thumbnail').forEach(item => { const active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', String(active)); });
});
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.selectedOptions[0];
  const buy = event.target.closest('.vk-buy');
  buy.querySelector('[data-price]').textContent = option.dataset.price;
  const button = buy.querySelector('[data-add]');
  button.disabled = option.dataset.available !== 'true';
  button.firstChild.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
});

  } catch(e) { console.error(e); }
})();
})();
